import React, {Component, useState, useEffect} from 'react';
import {connect} from 'react-redux';

const BookMainContainer = (props) => {

  const [isLoaded, setIsLoaded] = useState(false)
  const [state, setState] = useState({})

  useEffect(() => {

  })

  return (
    <div>
      BookMainContainer
    </div>
  )
}

const enhance = connect(
  state => ({
    ...state
  }),
  {}
);

export default enhance(BookMainContainer);
